export default __webpack_public_path__ + "static/media/clubhouse.53423a0d.png";